<template>
  <div class="files">
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-full">
            <b-button v-if="currentUserAccess('ProjectFilesDetails', this.UserActions.CREATE, this.project_id)"
                      class="button is-primary" icon-left="plus-thick" @click="addNewFileClicked">
              {{ $t('files-view.new-file-button') }}
            </b-button>
            <b-table class="files-table" :data="filesData" :striped="true" :hoverable="false"
                     :mobile-cards="true" :loading="isLoading" :scrollable="true" style="margin-top: 16px">
              <b-table-column field="name" :label="this.$t('files-view.file-name-column')" v-slot="props" sortable searchable>
                <a @click="downloadProjectFile(props.row)">{{ props.row.name }}</a>
              </b-table-column>
              <b-table-column field="email" :label="this.$t('files-view.email-column')"
                              v-slot="props" sortable searchable>
                {{ props.row.email }}
              </b-table-column>
              <b-table-column field="description" :label="this.$t('files-view.description-column')"
                              v-slot="props" sortable searchable>
                {{ props.row.description }}
              </b-table-column>
              <b-table-column field="date" :label="this.$t('files-view.date-column')"
                              v-slot="props" sortable>
                {{ props.row.date }}
              </b-table-column>
              <b-table-column v-slot="props" cellClass="has-text-right">
                <b-button class="button is-primary is-danger is-small" icon-left="delete" style="margin-left: 8px"
                          @click="deleteFileClicked(props.row)">
                  {{ $t('files-view.delete') }}
                </b-button>
              </b-table-column>
            </b-table>
          </div>
        </div>
      </div>
      <b-modal
          :width="640"
          v-model="isModalActive"
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal>
        <template #default="props">
          <FileUploadDetails v-bind:project_id="project_id" @close="props.close"
                             @fileUploaded="readFiles"></FileUploadDetails>
        </template>
      </b-modal>
    </section>
  </div>
</template>

<script>
import FileUploadDetails from "@/components/FileUploadDetails";
import firebase from "firebase";

export default {
  name: "FilesList",
  components: {
    FileUploadDetails
  },
  props: {
    'project_id': {
      type: String,
    }
  },
  data() {
    return {
      filesData: [],
      isLoading: false,
      isModalActive: false
    }
  },
  methods: {
    readFiles: function () {
      this.isModalActive = false;
      this.isLoading = true;
      this.filesData = [];
      this.getFilesRef().listAll().then((res) => {
        res.items.forEach((itemRef) => {
          console.log("project file: ", itemRef)
          itemRef.getMetadata()
              .then((metadata) => {
                console.log("project file meta: ", metadata)
                if (metadata !== null && metadata !== undefined) {
                  itemRef['date'] = this.getFormattedDateTime(metadata.timeCreated)
                  if (metadata.customMetadata !== null && metadata.customMetadata !== undefined) {
                    itemRef['description'] = metadata.customMetadata.description
                    itemRef['email'] = metadata.customMetadata.email
                  }
                }
                this.filesData.push(itemRef)
              })
              .catch((error) => {
                console.log("error reading project files meta: ", error);
              });
        });
        this.isLoading = false;
      }).catch((error) => {
        console.log("error reading project files: ", error);
        this.isLoading = false;
      });
    },
    getFilesRef: function () {
      const filesPath = this.getStorageRootFolder() + '/projects/' + this.project_id + '/files'
      console.log("files path: ", filesPath)
      return firebase.storage().ref(filesPath)
    },
    addNewFileClicked: function () {
      this.isModalActive = true;
    },
    downloadProjectFile: function (fileRef) {
      fileRef.getDownloadURL().then((downloadURL) => {
        console.log('project file available at', downloadURL);
        window.open(downloadURL);
      }).catch((error) => {
        console.log('project file download url error: ', error.message);
      });
    },
    deleteFileClicked: function (fileRef) {
      this.$buefy.dialog.confirm({
        title: this.$t('files-view.delete-file-title').toString(),
        message: this.$t('files-view.delete-file-message').toString(),
        confirmText: this.$t('files-view.delete-file-button').toString(),
        cancelText: this.$t('common.cancel').toString(),
        type: 'is-danger',
        hasIcon: true,
        icon: 'delete',
        onConfirm: () => {
          this.deleteFile(fileRef)
        }
      });
    },
    deleteFile: function (fileRef) {
      this.isLoading = true;
      fileRef.delete().then(() => {
        this.isLoading = false;
        this.showSuccess(this.$t("files-view.file-deleted"))
        this.readFiles();
      }).catch((error) => {
        this.isLoading = false;
        this.showError(error.message)
        console.log('error deleting project file: ', error.message);
      });
    }
  },
  computed: {},
  mounted() {
    this.readFiles()
  }
}
</script>